/* ==========================================================
   BetterShape — Vanilla JS
   ========================================================== */
(function () {
  'use strict';

  /* --------------------------------------------------------
     1. REVEAL ON SCROLL
     -------------------------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('.bs-reveal');
    if (!els.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('bs-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* --------------------------------------------------------
     2. ANIMATED COUNTERS
     Attribute: data-bs-counter="1234"
     -------------------------------------------------------- */
  function initCounters() {
    var els = document.querySelectorAll('[data-bs-counter]');
    if (!els.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        animateCounter(entry.target);
      });
    }, { threshold: 0.5 });

    els.forEach(function (el) { observer.observe(el); });
  }

  function animateCounter(el) {
    var target  = parseFloat(el.getAttribute('data-bs-counter'));
    var prefix  = el.getAttribute('data-bs-prefix')  || '';
    var suffix  = el.getAttribute('data-bs-suffix')  || '';
    var decimals = (target % 1 !== 0) ? 1 : 0;
    var duration = 1400;
    var start    = performance.now();

    function step(now) {
      var elapsed  = now - start;
      var progress = Math.min(elapsed / duration, 1);
      // ease out cubic
      var eased    = 1 - Math.pow(1 - progress, 3);
      var value    = (target * eased).toFixed(decimals);
      el.textContent = prefix + Number(value).toLocaleString() + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* --------------------------------------------------------
     3. PROGRESS BARS
     Attribute: data-bs-bar="59"  data-bs-delay="200"
     -------------------------------------------------------- */
  function initBars() {
    var els = document.querySelectorAll('[data-bs-bar]');
    if (!els.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var el    = entry.target;
        var pct   = parseFloat(el.getAttribute('data-bs-bar'));
        var delay = parseInt(el.getAttribute('data-bs-delay') || '0', 10);
        setTimeout(function () {
          el.style.width = pct + '%';
        }, delay);
      });
    }, { threshold: 0.3 });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* --------------------------------------------------------
     4. PDF FLIP BOOK
     .bs-flip-book[data-pages='["url1","url2",...]']
     -------------------------------------------------------- */
  function initFlipBooks() {
    var books = document.querySelectorAll('.bs-flip-book[data-pages]');
    books.forEach(initFlipBook);
  }

  function initFlipBook(book) {
    var pagesData;
    try {
      pagesData = JSON.parse(book.getAttribute('data-pages'));
    } catch (e) {
      return;
    }

    if (!pagesData || pagesData.length < 2) return;

    // Ensure even number
    if (pagesData.length % 2 !== 0) pagesData.push(pagesData[pagesData.length - 1]);

    var totalSpreads = Math.ceil(pagesData.length / 2);
    var currentSpread = 0;

    var leftImg   = book.querySelector('.bs-flip-book__left img');
    var rightImg  = book.querySelector('.bs-flip-book__right img');
    var leftPage  = book.querySelector('.bs-flip-book__left');
    var rightPage = book.querySelector('.bs-flip-book__right');
    var btnPrev   = book.querySelector('.bs-flip-book__btn--prev');
    var btnNext   = book.querySelector('.bs-flip-book__btn--next');
    var label     = book.querySelector('.bs-flip-book__label');
    var dots      = book.querySelectorAll('.bs-flip-book__dot');

    // Rebuild dots to match spreads
    var dotsContainer = book.querySelector('.bs-flip-book__dots');
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      for (var i = 0; i < totalSpreads; i++) {
        var dot = document.createElement('button');
        dot.className = 'bs-flip-book__dot' + (i === 0 ? ' bs-flip-book__dot--active' : '');
        dot.setAttribute('data-spread', i);
        dot.addEventListener('click', (function(idx) {
          return function() { goToSpread(idx); };
        })(i));
        dotsContainer.appendChild(dot);
      }
    }

    function updateDots() {
      var allDots = book.querySelectorAll('.bs-flip-book__dot');
      allDots.forEach(function (d, i) {
        d.classList.toggle('bs-flip-book__dot--active', i === currentSpread);
      });
    }

    function updateImages() {
      var li = pagesData[currentSpread * 2]     || '';
      var ri = pagesData[currentSpread * 2 + 1] || li;

      [leftPage, rightPage].forEach(function (p) { p.classList.add('bs-flipping'); });

      setTimeout(function () {
        if (leftImg)  { leftImg.src  = li; leftImg.alt  = 'Page ' + (currentSpread * 2 + 1); }
        if (rightImg) { rightImg.src = ri; rightImg.alt = 'Page ' + (currentSpread * 2 + 2); }
      }, 200);

      setTimeout(function () {
        [leftPage, rightPage].forEach(function (p) { p.classList.remove('bs-flipping'); });
      }, 400);
    }

    function updateControls() {
      if (btnPrev) btnPrev.disabled = currentSpread === 0;
      if (btnNext) btnNext.disabled = currentSpread === totalSpreads - 1;
      if (label) {
        var p1 = currentSpread * 2 + 1;
        var p2 = Math.min(currentSpread * 2 + 2, pagesData.length);
        label.textContent = 'Pages ' + p1 + '–' + p2 + ' of ' + pagesData.length;
      }
      updateDots();
    }

    function goToSpread(idx) {
      currentSpread = Math.max(0, Math.min(idx, totalSpreads - 1));
      updateImages();
      updateControls();
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { goToSpread(currentSpread - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { goToSpread(currentSpread + 1); });

    // Init first spread
    goToSpread(0);
  }

  /* --------------------------------------------------------
     5. TIP SELECTOR
     .bs-tip-selector[data-tip-href="URL"]
     -------------------------------------------------------- */
  function initTipSelectors() {
    var selectors = document.querySelectorAll('.bs-tip-selector');
    selectors.forEach(initTipSelector);
  }

  function initTipSelector(box) {
    var baseUrl   = box.getAttribute('data-tip-href') || '#';
    var presets   = box.querySelectorAll('.bs-tip-btn[data-amount]');
    var customIn  = box.querySelector('.bs-tip-custom');
    var cta       = box.querySelector('.bs-tip-cta');
    var selected  = 0;

    function updateCta() {
      if (!cta) return;
      if (selected > 0) {
        cta.removeAttribute('disabled');
        cta.textContent = 'Tip $' + selected + ' ♥';
        var sep = baseUrl.indexOf('?') > -1 ? '&' : '?';
        cta.href = baseUrl + sep + 'amount=' + selected;
      } else {
        cta.setAttribute('disabled', 'disabled');
        cta.textContent = 'Choose an amount above';
        cta.href = '#';
      }
    }

    function selectPreset(amount) {
      selected = amount;
      presets.forEach(function (btn) {
        var a = parseInt(btn.getAttribute('data-amount'), 10);
        btn.classList.toggle('bs-active', a === amount);
      });
      if (customIn) customIn.value = '';
      updateCta();
    }

    presets.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectPreset(parseInt(btn.getAttribute('data-amount'), 10));
      });
    });

    if (customIn) {
      customIn.addEventListener('input', function () {
        var v = parseFloat(customIn.value);
        presets.forEach(function (b) { b.classList.remove('bs-active'); });
        if (!isNaN(v) && v > 0) {
          selected = v;
        } else {
          selected = 0;
        }
        updateCta();
      });
    }

    updateCta();
  }

  /* --------------------------------------------------------
     INIT
     -------------------------------------------------------- */
  function init() {
    initReveal();
    initCounters();
    initBars();
    initFlipBooks();
    initTipSelectors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
